import React from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen, Clock3, MessageCircle, User } from 'lucide-react';
import { cn } from '../../lib/utils';
import { triggerLightHaptic } from '../../lib/haptics';

export const BottomNav = () => {
  const navItems = [
    { to: '/chat', icon: MessageCircle },
    { to: '/growth', icon: Clock3 },
    { to: '/report', icon: BookOpen },
    { to: '/profile', icon: User },
  ] as const;

  return (
    <nav
      className="app-bottom-nav pointer-events-none fixed bottom-0 left-1/2 z-40 w-full max-w-[960px] -translate-x-1/2"
      style={{
        paddingLeft: 'var(--app-page-gutter-x)',
        paddingRight: 'var(--app-page-gutter-x-right)',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 8px)',
      }}
    >
      <div
        className="pointer-events-auto flex h-16 items-center justify-around rounded-full border px-2"
        style={{
          background: 'rgba(255,255,255,0.30)',
          backdropFilter: 'blur(20px) saturate(140%)',
          WebkitBackdropFilter: 'blur(20px) saturate(140%)',
          borderColor: 'rgba(255,255,255,0.58)',
          boxShadow: '0 0 12px rgba(255,255,255,0.20), inset 0 1px 1px rgba(255,255,255,0.55)',
        }}
      >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => triggerLightHaptic()}
              className={({ isActive }) =>
                cn(
                  'h-[52px] w-[52px] rounded-full flex items-center justify-center transition-all duration-200',
                  isActive
                    ? 'scale-[1.08] bg-white [box-shadow:inset_0_2px_8px_rgba(255,255,255,0.9),0_10px_22px_rgba(15,23,42,0.16),0_0_0_1px_rgba(255,255,255,0.9)]'
                    : ''
                )
              }
            >
              {({ isActive }) => (
                <item.icon
                  size={26}
                  strokeWidth={2}
                  style={{ color: isActive ? '#5F7A63' : '#8FAF92' }}
                />
              )}
            </NavLink>
          ))}
      </div>
    </nav>
  );
};
